<template>
    <div class="search-tool-module" :class="{'is-mobile': isMobile}">
        <el-row type="flex">
            <el-col :lg="6" :md="6" :sm="12" class="search-container" :class="{'open': searchToolOpen}">
                <apt-search-tool @showBuildingView="showBuildingView"
                                 :locations="properties"
                                 :properties="filteredLocations"
                                 v-model="filters"
                />
            </el-col>
            <el-col :lg="18" :md="18" :sm="12" class="view-wrapper">
                <google-map v-if="loadedProperties.length > 0"
                            ref="googleMap"
                            :mapCenter="mapCenter"
                            :locations="loadedProperties"
                            :filters="filters"

                            @mapLoaded="moduleLoaded"
                />
                <div v-else="" class="map-placeholder"></div>
                <div class="search-results-container" :class="getClass">
                    <div class="controls">

                        <span class="box-checkbox"
                              @click.prevent="listViewOpen = false"
                              v-if="listViewOpen">
                            <font-awesome-icon :icon="icons.close"/>
                        </span>
                        <span class="box-checkbox"
                              v-if="!searchToolOpen && (listView === 'list' || !listViewOpen)"
                              @click.prevent="toggleView('building')">
                            <font-awesome-icon :icon="icons.building"/>
                        </span>
                        <span class="box-checkbox list-view"
                              v-if="!isMobile && (listView === 'building' || !listViewOpen)"
                              @click.prevent="toggleView('list')">
                            <font-awesome-icon :icon="icons.list"/>
                        </span>

                        <span class="box-checkbox icon-search"
                              :class="{'white': searchToolOpen}"
                              v-if="isMobile"
                              @click.prevent="toggleSearchForm">

                            <font-awesome-icon :icon="searchIcon"/>
                        </span>
                    </div>

                    <properties-list-view v-if="listViewOpen && listView==='list'"
                                          :properties="filteredLocations"
                                          :filters="filters"
                    />
                    <properties-block-view v-else-if="listViewOpen && listView==='building'"
                                           :properties="filteredLocations"
                                           :filters="filters"
                    />
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
    import _throttle from 'lodash/throttle'

    import ModuleMixin from './mixin.module'
    import AptSearchTool from './search/AptSearchTool'
    import PropertiesBlockView from './search/PropertiesBlockView'
    import PropertiesListView from './search/PropertiesListView'
    import GoogleMap from './GoogleMap'

    import {faTimes} from '@fortawesome/pro-light-svg-icons/faTimes'
    import {faList} from '@fortawesome/pro-light-svg-icons/faList'
    import {faSearch} from '@fortawesome/pro-light-svg-icons/faSearch'
    import {faBuilding} from '@fortawesome/pro-light-svg-icons/faBuilding'

    import {wpPropertiesAPI} from '../utils/api'
    import _pick from 'lodash/pick'
    import {MapEventHub} from './search/MapEventHub'

    export default {
        name: "SearchToolModule",
        mixins: [ModuleMixin],
        components: {GoogleMap, PropertiesBlockView, PropertiesListView, AptSearchTool},
        props: {
            module: Object,
        },
        data() {
            return {
                filters: {
                    beds: '',
                    baths: '',
                    city: '',
                    date: '',
                    state: '',
                    price: [0, 10000],
                    zip: '',
                    amenities: []
                },
                listView: '',
                listViewOpen: true,
                searchToolOpen: false,
                filteredProperties: [],
                loadedProperties: [],
            }
        },
        mounted() {
            // Have building view open by default on mobile, list on desktop
            this._onResize = _throttle(this.onResize, 500);
            window.addEventListener('resize', this._onResize);
            this._onResize();

        },
        asyncComputed: {
            async properties() {
                const wpRes = await wpPropertiesAPI.get('?per_page=100&orderby=menu_order&order=asc');
                const {headers, data: properties} = wpRes;

                if (properties) {
                    properties.forEach(property => {
                        this.loadedProperties.push(property);
                    });
                }
            }
        },
        computed: {
            map_idle() {
                return MapEventHub.idle
            },
            isMobile() {
                return MapEventHub.isMobile;
            },
            loadAnimationKey() {
                return this.pageLoaded ? '1' : 0;
            },
            mapCenter() {
                let mainLocation = {
                    lat: "40.421149",
                    lng: "-100.2315214"
                };

                let coordinates = _pick(mainLocation, 'lat', 'lng');

                return {
                    lat: parseFloat(coordinates.lat),
                    lng: parseFloat(coordinates.lng)
                }
            },
            currentTabView() {
                return (this.listView === 'list') ? PropertiesListView : PropertiesBlockView;
            },
            icons() {
                return {
                    close: faTimes,
                    search: faSearch,
                    building: faBuilding,
                    list: faList
                }
            },
            getClass() {
                return this.listViewOpen ? `active ${this.listView}` : '';
            },
            filteredLocations() {
                return MapEventHub.filteredProperties;
            },
            searchIcon() {
                return this.isMobile && this.searchToolOpen ? this.icons.close : this.icons.search;
            },
        },
        methods: {
            toggleView(type) {
                this.listViewOpen = true;
                this.listView = type;
            },
            toggleSearchForm() {
                this.listViewOpen = false;
                this.searchToolOpen = !this.searchToolOpen;
            },
            onResize() {
                // Have building view open by default on mobile, list on desktop
                this.listView = window.innerWidth < 1200 ? 'building' : 'list'
            },
            showBuildingView() {
                this.searchToolOpen = false;
                this.listViewOpen = true;
            }
        },
    }

</script>

<style lang="scss" type="text/scss" scoped>
    .controls {
        position: absolute;
        left: auto;
        right: -69px;
        width: 90px;
        top: 25px;
        z-index: 10;

        @media screen and (max-width: 1200px) {
            right: -39px;
            width: 90px;
            top: 17px;
        }

        .box-checkbox {
            cursor: pointer;
            background-color: #fff;
            width: 42px;
            height: 42px;
            border-radius: 50%;
            box-shadow: 0 0 2px rgba(#000, .1);
            padding: 9px;
            display: inline-block;
            text-align: center;
            line-height: 25px;

            &.white {
                background-color: #fff !important;
                color: #333333 !important;
            }

            &:first-child {
                box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
            }

            &.icon-search,
            &.list-view {
                background-color: #333333;
                color: #fff;
            }

            &.icon-search {
                box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
            }

            @media screen and (max-width: 1200px) {
                right: 10px;
                top: 15px;
                text-align: center;
                overflow: visible;
                display: block;
                margin-bottom: 3px;
            }
        }
    }
</style>

<style lang="scss" type="text/scss">

    .search-container {
        background: #333333;
        min-width: 350px;
        transition: all 0.8s cubic-bezier(0.4, 0, 0.2, 1) 0s;
        z-index: 1;

        @media screen and (max-width: 1200px) {
            position: absolute;
            right: -350px;
            height: 100%;
            min-width: initial;
            width: 100%;
            max-width: 350px;

            &.open {
                right: 0;
            }
        }
    }

    .search-results-container {
        background: $theme-white;
        width: auto;
        min-height: 500px;
        position: absolute;
        height: 100%;
        top: 0;
        left: 0;
        z-index: 1;

        &.building {
            min-width: 410px;
            max-width: 25vw;

            @media screen and (max-width: 420px) {
                min-width: 100%;
                max-width: 100%;
            }
        }

        &.list {
            min-width: 680px;
            max-width: 65vw;
        }

        .search-view {
            padding: 30px 30px 60px;
            height: 100%;
            overflow: scroll;
            -webkit-overflow-scrolling: touch;
        }

        @media screen and (max-width: 1200px) {
            right: 0;
            left: auto;
        }
    }

    .wrap-results {
        height: 100%;
        width: 100%;
    }

    .search-tool-module {
        padding-top: 20px;
        position: relative;
        max-height: 100vh;
        height: 100%;
        min-height: calc(100vh - 85px) !important;
        overflow: hidden;
    }

    .view-wrapper {
        position: relative;

        @media screen and (max-width: 1200px) {
            width: 100%;
        }
    }
</style>